import './Retention.scss';
import { ForwardedRef, forwardRef, useEffect, useState } from 'react';
import {
  Button,
  ButtonToolbar,
  Form,
  Input,
  InputNumber,
  useToaster,
  Message
} from 'rsuite';
import { useLocation, useNavigate } from 'react-router-dom';
import { useQuery } from '../utils';
import {
  deleteLocalRetentionUser,
  getLocalRetentionUser,
  useGetRetentionByIdQuery,
  useSendRetentionMutation
} from '../services';
import { useSelector } from 'react-redux';
import { selectDebugKey } from '../store/authSlice';
interface IProps {
  server: string;
}
export const Retention = ({ server }: IProps) => {
  const { state } = useLocation();
  const urlQuery = useQuery();
  const debugKey = useSelector(selectDebugKey);
  const debug_key = debugKey || state?.debug_key;
  const [email, setEmail] = useState<string>('');
  const [id, setId] = useState<string>('');
  const [formValue, setFormValue] = useState<Record<string, any>>({});
  const toaster = useToaster();
  const [sendRetention, submitRes] = useSendRetentionMutation();
  const navigate = useNavigate();

  const query = useGetRetentionByIdQuery(
    { id: id, email: email, server: server },
    { skip: !id || !email }
  );

  useEffect(() => {
    if (query?.isSuccess && query?.data.length) {
      const user = query.data?.[0];
      setFormValue({ ...user });
    }
  }, [query]);

  useEffect(() => {
    try {
      const user =
        getLocalRetentionUser() || state?.user || urlQuery.get('user');
      const dataString = atob(user || '');
      if (dataString) {
        const arr = dataString.split('+');
        if (arr.length > 1) {
          setId(arr[0]);
          setEmail(arr[1]);
        }
      }
    } catch (error) {
      console.warn('decode user retention url failed', error);
    } finally {
      deleteLocalRetentionUser();
    }
  }, []);

  const onSubmit = () => {
    console.info('submit instance retention', formValue);
    sendRetention({
      data: formValue,
      server: server
    });
  };
  const onCancel = () => {
    navigate(`/organization`, {
      state: {
        debug_key
      }
    });
  };

  useEffect(() => {
    if (submitRes?.isSuccess) {
      const header = 'VM Retention Submitted successfully!';
      const content = 'Will redirect to Organization Page ...';
      const message = (
        <Message
          showIcon
          type="success"
          closable
          header={header}
          onClose={() => {
            navigate(`/organization`, {
              state: {
                debug_key
              }
            });
          }}
        >
          {content}
        </Message>
      );
      toaster.push(message, {
        placement: 'topCenter',
        duration: 5000
      });
    } else if (submitRes?.isError) {
      const header = 'VM Retention Submitted Failed!';
      const message = (
        <Message showIcon type="warning" closable header={header}></Message>
      );
      toaster.push(message, {
        placement: 'topCenter',
        duration: 5000
      });
    }
  }, [submitRes]);
  return (
    <div className="retention-container">
      <div className="retention-form-container">
        <Form
          layout="horizontal"
          formValue={formValue}
          onChange={(formValue) => {
            setFormValue(formValue);
          }}
        >
          <Form.Group controlId="account_email">
            <Form.ControlLabel>Email</Form.ControlLabel>
            <Form.Control name="account_email" disabled={true} />
          </Form.Group>
          <Form.Group controlId="user_name">
            <Form.ControlLabel>User Name</Form.ControlLabel>
            <Form.Control name="user_name" disabled={true} />
          </Form.Group>
          <Form.Group controlId="account_id">
            <Form.ControlLabel>Account ID</Form.ControlLabel>
            <Form.Control name="account_id" disabled={true} />
          </Form.Group>
          <Form.Group controlId="image_type">
            <Form.ControlLabel>Image Type</Form.ControlLabel>
            <Form.Control name="image_type" disabled={true} />
          </Form.Group>
          <Form.Group controlId="cloud_instance_expiry_date">
            <Form.ControlLabel>Instance Expired Date</Form.ControlLabel>
            <Form.Control name="cloud_instance_expiry_date" disabled={true} />
          </Form.Group>
          <Form.Group controlId="user_manager">
            <Form.ControlLabel>Manager</Form.ControlLabel>
            <Form.Control name="user_manager" />
          </Form.Group>
          <Form.Group controlId="user_title">
            <Form.ControlLabel>User Title</Form.ControlLabel>
            <Form.Control name="user_title" />
          </Form.Group>
          <Form.Group controlId="user_office_location">
            <Form.ControlLabel>Office Location</Form.ControlLabel>
            <Form.Control name="user_office_location" />
          </Form.Group>
          <Form.Group controlId="number_of_fortigates">
            <Form.ControlLabel>Number of Fortigate</Form.ControlLabel>
            <Form.Control name="number_of_fortigates" accepter={InputNumber} />
          </Form.Group>
          <Form.Group controlId="purpose_of_instance">
            <Form.ControlLabel>Purpose of Instance</Form.ControlLabel>
            <Form.Control name="purpose_of_instance" accepter={Textarea} />
          </Form.Group>
          <Form.Group>
            <ButtonToolbar style={{ justifyContent: 'space-around' }}>
              <Button appearance="primary" onClick={onSubmit}>
                Submit
              </Button>
              <Button appearance="default" onClick={onCancel}>
                Cancel
              </Button>
            </ButtonToolbar>
          </Form.Group>
        </Form>
      </div>
    </div>
  );
};
export type Ref = ForwardedRef<HTMLInputElement>;
const Textarea = forwardRef((props: any, ref: Ref) => (
  <Input as="textarea" {...props} ref={ref} />
));
